/* eslint-disable import/prefer-default-export */
export const modalStyles = {
  dialog: {
    height: { xs: '85vh', md: '70vh' },
    maxWidth: { xs: '100vw', md: '50vw' },
  },
  relative: {
    position: 'relative',
    pt: 1,
  },
  label: {
    position: { xs: 'absolute', md: 'relative' },
    zIndex: 1,
    left: { xs: '16px', md: 'unset' },
    top: { xs: 0, md: 'unset' },
    background: '#fff',
    px: { xs: 0.5, md: 0 },
    fontSize: { xs: '0.85em', md: 'inherit' },
  },
};
/* eslint-enable import/prefer-default-export */
